import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import styled from "styled-components";
import { useTranslation } from "@i18n/hooks";
import { resetArrayOfEditedForms } from "../store/slices/CoreSlice";
import { useTypedDispatch } from "../store/store.redux";

type OwnProps = {
	showDialog?: boolean;
	setShowDialog?: any;
	callback?: any;
	value?: any;
	confirmNavigation?: any;
	cancelNavigation?: any;
};

export const WarningUnsavedChangesDialog = ({
	callback,
	value,
	confirmNavigation,
	cancelNavigation,
	setShowDialog,
}: OwnProps) => {
	const { t } = useTranslation("common");

	const isShowDialogFalseDefined = () => {
		if (setShowDialog) {
			setShowDialog(false);
		}
	};

	const defineNavigation = () => {
		if (confirmNavigation) {
			confirmNavigation();
		}
	};
	const blockNavigation = () => {
		if (cancelNavigation) {
			cancelNavigation();
		}
	};
	const isCallbackDefined = () => {
		if (callback) {
			callback(value);
		}
	};

	const dispatch = useTypedDispatch();
	return (
		<div>
			<DialogContainer
				header={t("dialogs.unsavedChanges.title")}
				className="flex"
				position="center"
				contentClassName="flex"
				visible={true}
				onHide={() => {
					isShowDialogFalseDefined();
					blockNavigation();
				}}
			>
				<div className="mb-2">{t("dialogs.unsavedChanges.message")}</div>
				<div className="mb-4">{t("dialogs.unsavedChanges.confirm")}</div>
				<ButtonsWrapper>
					<LeftButton
						onClick={() => {
							isShowDialogFalseDefined();
							blockNavigation();
						}}
					>
						{t("actions.cancel")}
					</LeftButton>
					<Button
						onClick={() => {
							dispatch(resetArrayOfEditedForms());
							isCallbackDefined();
							isShowDialogFalseDefined();
							defineNavigation();
						}}
					>
						{t("actions.ok")}
					</Button>
				</ButtonsWrapper>
			</DialogContainer>
		</div>
	);
};

const ButtonsWrapper = styled.div`
	width: 100%;
	display: flex;
	justify-content: flex-end;
`;
const LeftButton = styled(Button)`
	margin-right: 10px;
`;
const DialogContainer = styled(Dialog)`
	width: 30%;
	.p-dialog-content {
		justify-content: space-between;
		display: flex;
		flex-direction: column;
	}
`;
